<script>
  import ValidationMessage from '../../../../../components/form/ValidationMessage.vue'
  import {required, minLength, maxLength} from 'vuelidate/lib/validators'

  export default {
    components: {ValidationMessage},
    name: 'submission-text-field',
    props: {
      model: {default: '', type: String},
      minLengthSize: {default: 0},
      maxLengthSize: {default: 100},
      placeholder: {default: '', type: String},
      isInvalid: {default: false, type: Boolean},
      showHelper: {default: false, type: Boolean}
    },
    data () {
      return {
        value: ''
      }
    },
    validations () {
      return {
        value: {
          required,
          minLength: minLength(this.minLengthSize),
          maxLength: maxLength(this.maxLengthSize)
        }
      }
    },
    watch: {
      value: {
        handler: function () {
          this.$emit('update:isInvalid', this.$v.value.$invalid)
          this.$emit('update:model', this.value)
        },
        deep: true
      }
    },
    beforeMount () {
      this.value = this.model
    }
  }
</script>

<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="showHelper ? 12 : 24">
                <el-input v-model="value"
                          :minlength="minLengthSize"
                          :maxlength="maxLengthSize"
                          :placeholder="showHelper ? 'Verifique as opções ao lado' : placeholder"
                          @input="$v.value.$touch()">
                </el-input>
            </el-col>
            <el-col v-if="showHelper" :span="12">
                <el-alert title="Observações"
                          class="submission-tips"
                          type="warning"
                          :closable="false">
                    <br>
                    <span v-html="placeholder"></span>
                </el-alert>
            </el-col>
        </el-row>
        <div class="el-form-item-validation">
            <validation-message v-if="$v.value.$invalid && $v.value.$dirty"/>
            <span>&nbsp;</span>
            <div class="max-length">
                Restam <span>{{maxLengthSize - value.length}}</span> caracteres (Mín:
                {{minLengthSize}} - Máx: {{maxLengthSize}})
            </div>
        </div>
    </div>
</template>
